import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { getResetRecaptchaKey } from '../utils';

export default function ForgotForm({ email, error, loading, onEmailChange, onBack, onSubmit }) {
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [localError, setLocalError] = useState('');

    const handleSubmit = e => {
        e.preventDefault();
        if (!email || !recaptchaToken) {
            setLocalError('STATIC.PAGES.LOGIN.RESET_VALIDATION');
            return;
        }
        setLocalError('');
        onSubmit(recaptchaToken);
    };

    return (
        <form className="registration-form forgot-password-form" onSubmit={handleSubmit}>
            <div className="forgot-password-email form-group" style={{ marginBottom: 25 }}>
                <label htmlFor="id_email"><Translate id="STATIC.PAGES.LOGIN.EMAIL" /></label>
                <input
                    id="id_email" className="form-control" maxLength={254} type="email"
                    placeholder="Your email address"
                    value={email} onChange={e => onEmailChange(e.target.value)}
                />
            </div>
            <ReCAPTCHA sitekey={getResetRecaptchaKey()} onChange={setRecaptchaToken} />
            {error ? (
                <div className="login-form-error-message text-danger">{error}</div>
            ) : localError ? (
                <div className="login-form-error-message text-danger"><Translate id={localError} /></div>
            ) : null}
            <button type="submit" className="btn btn-block btn-singular btn-primary" disabled={loading}>
                <Translate id="STATIC.PAGES.LOGIN.RESET_BUTTON" />
            </button>
            <a className="form-underlink pull-left" href="#" onClick={e => { e.preventDefault(); onBack(); }}>
                <Translate id="STATIC.PAGES.LOGIN.BACK_TO_LOGIN" />
            </a>
        </form>
    );
}

ForgotForm.propTypes = {
    email: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};
